import React from 'react';
import styled from 'styled-components';
import SymbolFormat from './SymbolFormat';
import { NumberComponents } from '../../../svgs/NumberIcons';
import { Separator } from './Separator';

const HelpContainer = styled.div`
  color: ${({ theme }) => theme.c.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  .content-section--help {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .content-section--help-heading {
    ${({ theme }) => theme.typographyRebrand.heading['2xl']}
    margin-bottom: ${({ theme }) => theme.unit(6)};

    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.tablet}px) {
      margin-bottom: ${({ theme }) => theme.unit(8)};
    }
    
    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
      margin-bottom: ${({ theme }) => theme.unit(10)};
    }
  }

  .content-section--help-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.unit(6)};

    .help-item-number {
      text-align: center;
    }

    .help-item-header {
      ${({ theme }) => theme.typographyRebrand.heading.lg}
      margin-bottom: ${({ theme }) => theme.unit(2)};
      text-align: center;

      @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
        text-align: left;
      }
    }

    .help-item-text {
      ${({ theme }) => theme.typographyRebrand.body.lg}
      margin-bottom: ${({ theme }) => theme.unit(1)};
      text-align: center;

      @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
        text-align: left;
      }
    }
    
    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
      flex-direction: row;
    }

    ol {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .content-section--help-item-content {
      display: flex;
      flex-direction: column;
      gap: ${({ theme }) => theme.unit(2)};
      
      @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
        flex-direction: row;
      }
    }
  }

  .content-section--help-image {
    display: flex;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 324px;
    }

    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
      img {
        max-width: 90vw;
      }
    }

    @media (min-width: ${(p) => p.theme.minWidthBreakpoint.desktop}px) {
      img {
        width: 462px;
      }
    }
  }
`;

const HelpSection = (props) => {
  const {
    imageUrl,
    titleText,
    blocks = []
  } = props;

  return (
    <HelpContainer id="how-it-works-section">
      <div className="content-section content-section--help">
        <SymbolFormat className="content-section--help-heading" elementTag="h2" text={titleText} />
        <div className="content-section--help-content">
          <div className="content-section--help-image">
            <img src={`https://${imageUrl}`} />
          </div>
          <div className="content-section--help-body">
            <ol>
              { blocks && blocks.map((block) => {
                const Number = NumberComponents[block.bulletComponent] || null;
                return (
                  <li>
                    <div className="content-section--help-item-content">
                      <div className="help-item-number"><Number /></div>
                      <div className="help-item-body">
                        <SymbolFormat className="help-item-header" text={block.title} />
                        <div className="help-item-text">{block.body}</div>
                      </div>
                    </div>

                    <Separator padding={3} />
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </HelpContainer>
  );
};

export default HelpSection;
